import { definePreset } from '@primevue/themes';
import PrimeAura from '@primevue/themes/aura';

const preset = definePreset(PrimeAura, {
  // https://v4.primevue.org/theming/styled
});

export default {
  preset,
};
